export default __webpack_public_path__ + "static/media/PFMAM__Site_Logo.6c4edc12.png";